export default __webpack_public_path__ + "static/media/pic3.01de4378.jpg";